// GENERATO da scripts/migrate-i18n.mjs — non modificare a mano.

export interface LanguageMeta {
  readonly code: string;
  readonly native: string;
  readonly flag: string;
  readonly dir: 'ltr' | 'rtl';
}

export const LANGUAGES: readonly LanguageMeta[] = [
  {
    "code": "it",
    "native": "Italiano",
    "flag": "🇮🇹",
    "dir": "ltr"
  },
  {
    "code": "en",
    "native": "English",
    "flag": "🇬🇧",
    "dir": "ltr"
  },
  {
    "code": "fr",
    "native": "Français",
    "flag": "🇫🇷",
    "dir": "ltr"
  },
  {
    "code": "de",
    "native": "Deutsch",
    "flag": "🇩🇪",
    "dir": "ltr"
  },
  {
    "code": "es",
    "native": "Español",
    "flag": "🇪🇸",
    "dir": "ltr"
  },
  {
    "code": "pt",
    "native": "Português",
    "flag": "🇵🇹",
    "dir": "ltr"
  },
  {
    "code": "nl",
    "native": "Nederlands",
    "flag": "🇳🇱",
    "dir": "ltr"
  },
  {
    "code": "pl",
    "native": "Polski",
    "flag": "🇵🇱",
    "dir": "ltr"
  },
  {
    "code": "ru",
    "native": "Русский",
    "flag": "🇷🇺",
    "dir": "ltr"
  },
  {
    "code": "ja",
    "native": "日本語",
    "flag": "🇯🇵",
    "dir": "ltr"
  },
  {
    "code": "zh",
    "native": "中文",
    "flag": "🇨🇳",
    "dir": "ltr"
  }
] as const;

export const LANGUAGE_CODES = LANGUAGES.map((l) => l.code);
export const FALLBACK_LANGUAGE = 'it';
